import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import PdfLinkActions from "src/components/PdfLinkActions";
import Header from "src/components/wizard/Header";
import Footer from "src/components/wizard/Footer/Footer";
import useAuth from "src/hooks/useAuth";
import transferShipmentImage from "../../../../../assets/images/transfer-shipment.webp";

export default function Step0Introduction({ shipment, step, totalSteps, onNext, onClose }) {
  const { user } = useAuth();
  const { settings } = user.company;
  const filterField2 = settings?.filter_field2;

  const shipmentInfo = (
    <Box display="flex" alignItems="center" gap={1}>
      <Typography>{shipment?.shipmentId}</Typography>
      <PdfLinkActions
        resourceType="shipment_pdfs"
        resourceId={shipment?.id}
        sx={{
          textTransform: "none",
          fontSize: 12,
          py: 0.2,
          px: 1,
          minWidth: "auto",
          height: 25,
          borderRadius: 10,
        }}
      />
    </Box>
  );

  return (
    <>
      <Header
        title="Transfer Inbound Shipment"
        info={shipmentInfo}
      />
      <Box
        p={2}
        minHeight={400}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Box
          component="img"
          src={transferShipmentImage}
          alt="Transfer Shipment"
          sx={{
            maxWidth: 275,
            width: "100%",
            height: "auto",
            mb: 3,
            borderRadius: '10px',
          }}
        />
        <Box py={2} px={2}>
          <Typography fontSize={16} align="center" color="text.secondary">
            This tool helps you transfer this inbound shipment to a different {filterField2?.toLowerCase() || "customer"} or split it into
            separate shipments.
          </Typography>
        </Box>
      </Box>
      <Footer step={step} steps={totalSteps} showRaceMode={false}>
        <Button variant="contained" color="primary" onClick={onNext}>
          Start
        </Button>
      </Footer>
    </>
  );
}
